// extracted by mini-css-extract-plugin
module.exports = {"container":"SecondaryButton_container__1R3t5","label":"SecondaryButton_label__EefV2"};